import { render, staticRenderFns } from "./CourseTest.vue?vue&type=template&id=64c915fa&"
import script from "./CourseTest.vue?vue&type=script&lang=js&"
export * from "./CourseTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports